/* ============================================
   GTE — Theme JavaScript
   ============================================ */

(function () {
  'use strict';

  /* --- Mobile Menu --- */
  const menuToggle = document.getElementById('MenuToggle');
  const siteNav = document.getElementById('SiteNav');

  if (menuToggle && siteNav) {
    menuToggle.addEventListener('click', function () {
      const isOpen = this.classList.toggle('is-open');
      siteNav.classList.toggle('is-open');
      this.setAttribute('aria-expanded', isOpen);
    });
  }

  /* --- Quantity Buttons --- */
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.qty-btn');
    if (!btn) return;

    const wrap = btn.closest('.product-single__quantity') || btn.parentElement;
    const input = wrap.querySelector('.qty-field');
    if (!input) return;

    let val = parseInt(input.value, 10) || 1;
    const min = parseInt(input.min, 10) || 1;

    if (btn.dataset.action === 'increase') {
      input.value = val + 1;
    } else if (btn.dataset.action === 'decrease' && val > min) {
      input.value = val - 1;
    }

    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* --- Product Variant Selector --- */
  const variantSelect = document.getElementById('VariantSelect');
  const optionSelects = document.querySelectorAll('[data-option-index]');

  if (variantSelect && optionSelects.length > 0) {
    const variantsJson = document.getElementById('ProductVariantsJson');
    let variants = [];

    if (variantsJson) {
      try {
        variants = JSON.parse(variantsJson.textContent);
      } catch (e) {
        // Silent fail
      }
    }

    optionSelects.forEach(function (select) {
      select.addEventListener('change', function () {
        const selectedOptions = [];
        optionSelects.forEach(function (s) {
          selectedOptions.push(s.value);
        });

        const matched = variants.find(function (v) {
          return v.options.every(function (opt, i) {
            return opt === selectedOptions[i];
          });
        });

        if (matched) {
          variantSelect.value = matched.id;
          updateProductInfo(matched);
        }
      });
    });
  }

  function updateProductInfo(variant) {
    const currentPrice = document.getElementById('CurrentPrice');
    const comparePrice = document.getElementById('ComparePrice');
    const addToCart = document.getElementById('AddToCart');

    if (currentPrice) {
      currentPrice.textContent = formatMoney(variant.price);
    }

    if (comparePrice) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        comparePrice.textContent = formatMoney(variant.compare_at_price);
        comparePrice.style.display = '';
      } else {
        comparePrice.style.display = 'none';
      }
    }

    if (addToCart) {
      if (variant.available) {
        addToCart.disabled = false;
        addToCart.textContent = addToCart.dataset.addText || 'ADD TO CART';
      } else {
        addToCart.disabled = true;
        addToCart.textContent = addToCart.dataset.soldText || 'SOLD OUT';
      }
    }
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* --- Product Image Gallery --- */
  const thumbnails = document.querySelectorAll('.product-single__thumb');
  const mainImage = document.getElementById('MainImageTag');

  if (thumbnails.length > 0 && mainImage) {
    thumbnails.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbnails.forEach(function (t) {
          t.classList.remove('is-active');
        });
        this.classList.add('is-active');
        mainImage.src = this.dataset.imageUrl;
      });
    });
  }

  /* --- Collection Sort --- */
  const sortSelect = document.getElementById('SortBy');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  /* --- Smooth Scroll for Anchor Links --- */
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

})();
